export default class globalTools {
    constructor() {

        // detect input - add body class for future use

        function testForPointer() {

            document.addEventListener('pointerover', function (e) {

                const body = document.querySelector('body');

                body.classList.remove('mouse-active', 'touch-active');

                if (e.pointerType === 'mouse') {
                    body.classList.add('mouse-active');
                }
                if (e.pointerType === 'touch') {
                    body.classList.add('touch-active');
                }
            });
        }

        testForPointer();
    }
}
